import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		padding: THEME.spacing.md,
	},
	controls: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
	},
	empty: {
		color: THEME.colors.text.light,
		padding: THEME.spacing.lg,
		textAlign: 'center',
	},
	message: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	warning: {
		background: THEME.colors.pill.yellow.background,
		border: `1px solid ${THEME.colors.pill.yellow.border}`,
		borderRadius: THEME.common.borderRadius,
		fontSize: THEME.typography.fontSizes.sm,
		padding: THEME.spacing.sm,
	},
	row: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.sm,
	},
	rowUrgent: {
		borderColor: THEME.colors.pill.red.border,
	},
	rowHeader: {
		alignItems: 'baseline',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
	},
	subject: {
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	sender: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	pills: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.xs,
	},
	rationale: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontStyle: 'italic',
	},
	rowBody: {
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	rowMain: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	sectionHeading: {
		alignItems: 'baseline',
		borderBottom: THEME.common.border,
		color: THEME.colors.text.dark,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		gap: THEME.spacing.sm,
		paddingBottom: THEME.spacing.xs,
	},
	// The second heading is quieter than the first: the split is only useful if one side reads as the
	// one to deal with.
	sectionHeadingMuted: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.md,
		marginTop: THEME.spacing.lg,
	},
	sectionCount: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.standard,
	},
	threads: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	filterBar: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.xs,
	},
	filterDivider: {
		background: THEME.colors.border.main,
		height: 20,
		margin: `0 ${THEME.spacing.xs}px`,
		width: 1,
	},
	bulkBar: {
		alignItems: 'center',
		background: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.sm,
	},
	accountLink: {
		color: THEME.colors.primary.main,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
	pillButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		display: 'inline-flex',
		padding: 0,
	},
	email: {
		background: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		maxHeight: 320,
		overflowY: 'auto',
		padding: THEME.spacing.sm,
	},
	emailMessage: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	emailBody: {
		fontSize: THEME.typography.fontSizes.sm,
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
	},
	compose: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	actions: {
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.xs,
	},
});
